<template>
  <div class="posi-fiexd" v-if="dataVal.flag">
    <div class="posi-center">
      <div class="posi-head">
        <div class="posi-title">{{ dataVal.title }}</div>
        <i @click="handleClose" class="el-icon-close"></i>
      </div>
      <div class="posi-over">
        <div class="item">
          <div class="item-title">一级分销佣金</div>
          <div class="item-input">
            <input
              type="text"
              v-model="fromData.firstmoney"
              placeholder="请输入一级分销佣金"
            />
          </div>
        </div>
        <div class="item">
          <div class="item-title">二级分销佣金</div>
          <div class="item-input">
            <input
              type="text"
              v-model="fromData.secmoney"
              placeholder="请输入二级分销佣金"
            />
          </div>
        </div>
      </div>

      <div class="posi-btn">
        <div class="hui" @click="handleClose">{{ dataVal.btn2 || "取消" }}</div>
        <div @click="handleSubmit">{{ dataVal.btn1 || "确认" }}</div>
      </div>
    </div>
  </div>
</template>
        <script>
export default {
  name: "FillIn",
  props: ["dataVal"],
  data() {
    return {
      fromData: {
        city: "济南市",
        goods_ids: "",
        firstmoney: "",
        secmoney: "",
      },
      type: "add",
    };
  },
  mounted() {},
  methods: {
    //提交
    async handleSubmit() {
      if (this.type == "add") {
        let res = await this.$api.fenxiaoAddcustomize({
          ...this.fromData,
        });

        if (res.code == 1) {
          this.$message.success(res.msg);
          let obj = {
            flag: false,
            submitFlag: true,
          };
          this.$emit("addCommissionCell", obj);
        }
      } else {
        let res = await this.$api.fenxiaoEditcustomize({
          id: this.fromData.goods_ids,
          firstmoney: this.fromData.firstmoney,
          secmoney: this.fromData.secmoney,
        });

        if (res.code == 1) {
          this.$message.success(res.msg);
          let obj = {
            flag: false,
            submitFlag: true,
          };
          this.$emit("addCommissionCell", obj);
        }
      }
    },
    //关闭
    handleClose() {
      let obj = {
        flag: false,
        submitFlag: false,
      };
      this.$emit("addCommissionCell", obj);
    },
  },
  watch: {
    dataVal: {
      handler(newVal, oldVal) {
        if (newVal.flag) {
          this.fromData.city = newVal.city;
          this.fromData.goods_ids = newVal.goods_ids;
          this.fromData.firstmoney = newVal.firstmoney;
          this.fromData.secmoney = newVal.secmoney;
          this.type = newVal.type;
        }
      },
      deep: true,
    },
  },
};
</script>
        <style lang="scss" scoped>
.posi-fiexd {
  @include flex-center(center, center);
}
.posi-center {
  width: 55.886vw;
  border-radius: 25px;
  background-color: #fff;
  overflow: hidden;
  padding-bottom: 5vh;
  .posi-head {
    height: 70px;
    padding: 0 36px 0 32px;
    background-color: #f2f6ff;
    @include flex-center(space-between, center);
    .posi-title {
      font-size: 20px;
      font-weight: 700;
      color: #202224;
    }
    i {
      font-size: 20px;
      color: #aeaeb2;
      cursor: pointer;
    }
  }
  /deep/.posi-over {
    padding: 4vh 0 5vh;
    display: flex;
    justify-content: center;
    .item {
      font-size: 14px;
      &:first-child {
        margin-right: 2.116vw;
      }
      .item-title {
        display: flex;
        &::after {
          display: block;
          content: "*";
          color: #ff3b30;
        }
      }
      .item-input {
        margin-top: 11px;
        input {
          width: 23.148vw;
          height: 52px;
          line-height: 52px;
          background-color: #f2f2f7;
          padding-left: 2.315vw;
          border: none;
          outline: none;
          border-radius: 5px;
        }
      }
    }
  }
  .posi-btn {
    @include flex-center(center, center);
    div {
      width: 100px;
      height: 35px;
      background-color: #007aff;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #fff;
      @include flex-center(center, center);

      cursor: pointer;
    }
    .hui {
      margin-right: 42px;
      background-color: #f5f5f5;
      color: #363636;
    }
  }
}
</style>